exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#myimg[data-v-ab1c4ff0]{width:350px;margin:50px auto}.upLoadArt[data-v-ab1c4ff0]{padding-top:20px;text-align:center}", ""]);

// exports
